import styles from "./InfoPage.module.scss"; // Імпортуємо SCSS файл для стилів
import Nav from "@/components/Header/Nav/Nav";
import Footer from "@/components/Footer/Footer";
import CookiePopupButton from "@/components/CookieBanner/CookiePopupButton.tsx";
import { useEffect } from "react";

const PaymentFailed = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Скролимо в верх сторінки
  }, []);

  return (
    <div>
      <title>
        Zahlung fehlgeschlagen – HIXA – DSG Getriebe Reparatur & Wartung
      </title>
      <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
      <Nav />
      <h2 className={` sectionContainer ${styles.title}`}>
        Zahlung fehlgeschlagen
      </h2>
      <div className="container sectionContainer sectionContainerWhite">
        <p className={styles.infoPageText}>
          Leider war Ihre Zahlung nicht erfolgreich.
          <br />
          Bitte überprüfen Sie Ihre Zahlungsdetails und versuchen Sie es erneut.
        </p>

        <p className={styles.infoPageText}>
          Falls das Problem weiterhin besteht, wenden Sie sich bitte an unseren
          Kundensupport:
          <br />
          Telefon: +49 30 520 151 91
          <br />
          E-Mail: kunden@hixa.eu
        </p>
      </div>
      <CookiePopupButton />
      <Footer />
    </div>
  );
};

export default PaymentFailed;
